import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import {titleCase} from '../../../../utils/views/pages/Dynamics'

const DeviceInformation = (props) => {
    const device = props.device
    const formDisabled = props.formDisabled
    const setDevice = props.setDevice
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {
        //console.log(!e.target.value.trim() && e.target.required)
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {                
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {
        
        device[e.target.name] = e.target.value
        setDevice(device)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Device information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-uniqueId"
                            >
                                Unique ID
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={device?.uniqueId}
                                id="input-uniqueId"
                                name="uniqueId"
                                placeholder="Device Unique ID Code"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>       
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-model"
                            >
                                Model
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-model"
                                defaultValue={device?.model}
                                type="text"
                                name="model"
                                placeholder="Device Model"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-brand"
                            >
                                Brand
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-brand"
                                defaultValue={device?.brand}
                                type="text"
                                disabled={formDisabled}
                                placeholder="Device Brand"
                                name="brand"
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default DeviceInformation;